<template>
  <b-row>
    <sweet-modal
      ref="shopmodal"
      @close="closeNested"
      title="Add a Bot"
      width="60vw"
      modal-theme="dark"
    >
      <div v-if="!showNested">You can close this dialogue</div>

      <div v-if="showNested" style="height: 25vh">
        <b-form>
          <b-form-group
            id="input-group-1"
            label="Bot Name:"
            label-for="input-1"
            description="Choose a super unique name for your bot, only alphanumeric characters"
          >
            <b-form-input
              id="input-1"
              v-model="new_bot.name"
              placeholder="Enter bot name"
              required
              :state="validation"
              @change="handleNameChange"
            ></b-form-input>

            <b-form-invalid-feedback :state="validation">
              We're sorry but that name is not available
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group
            id="input-group-3"
            label="Bot Type:"
            label-for="input-3"
            description="Choose a type of bot"
          >
            <b-form-select
              id="input-3"
              v-model="new_bot.bot_type"
              :options="botTypes"
              required
            ></b-form-select>
          </b-form-group>

          <b-button
            :disabled="
              isBusy ||
              new_bot.name.length < 4 ||
              !validation
            "
            variant="success"
            style="width: 100%; margin-bottom: 19px"
            @click="createBot"
            >Submit</b-button
          >

          <b-spinner
            v-if="isBusy"
            variant="primary"
            label="Spinning"
          ></b-spinner>
        </b-form>
      </div>
    </sweet-modal>

    <div class="margin-top-default-content wide-content-default">
      <transition name="slide">
        <b-card class="bg-dark">
          <b-container style="margin: 9px; margin-left: -5px">
            <el-input
              class="bg-dark"
              v-model="tablefilter"
              type="text"
              style="border-radius: 19px; width: 30vw; margin-right: 13px"
              placeholder="Search"
            ></el-input>
            <b-button class="bg-dark" variant="primary" @click="openNested"
              >Create New Bot</b-button
            >
          </b-container>

          <div slot="header" v-html="caption"></div>

          <b-table
            style="color: white"
            class="bg-dark"
            :filter="tablefilter"
            responsive
            :hover="hover"
            striped
            :busy="isBusy"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
          >
            <template slot="is_updating" slot-scope="data">
              <i
                class="fa fa-spinner fa-spin"
                v-if="data.item.is_updating"
                style="color: red"
              ></i
              ><b v-if="data.item.is_updating" style="margin: 3px; color: red"
                >Updating</b
              >
              <i
                class="fa fa-check-circle-o"
                v-if="!data.item.is_updating"
                style="color: green"
                ><b style="margin: 2px">Ready</b></i
              >
            </template>

            <template slot="is_pending" slot-scope="data">
              <i
                class="fa fa-ban"
                v-if="data.item.is_pending"
                style="color: red"
                ><b style="margin: 2px">Install pending</b></i
              >
              <i
                class="fa fa-check-circle-o"
                v-if="!data.item.is_pending"
                style="color: green"
                ><b style="margin: 2px">Active</b></i
              >
            </template>

            <template slot="is_accessible" slot-scope="data">
              <i
                class="fa fa-ban"
                v-if="!data.item.is_accessible"
                style="color: red"
                ><b style="margin: 2px">Unavailable</b></i
              >
              <i
                class="fa fa-check-circle-o"
                v-if="data.item.is_accessible"
                style="color: green"
                ><b style="margin: 2px">Accessible</b></i
              >
            </template>

            <template slot="actions" slot-scope="data">
              <b-button
                variant="primary"
                @click="rowClicked(data.item.id)"
                style="margin-right: 5px"
                >View</b-button
              >
            </template>

            <div slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </b-table>
          <nav>
            <b-pagination
              size="sm"
              :total-rows="getRowCount(items)"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Prev"
              next-text="Next"
              hide-goto-end-buttons
            />
          </nav>
        </b-card>
      </transition>
    </div>
  </b-row>
</template>

<script>
import { createItemJsonPost, getTableData } from "../../services/v1/api_store";

import { BASE_URL } from "../../../env";

import { DEFAULT_TOAST } from "../../services/v1/constants";

const opts = DEFAULT_TOAST;

function bn() {
  console.log("hhhhhhhhh");
}

export default {
  name: "Stores",
  mounted() {
    let self = this;
    getTableData(this.$store, "users/bots/list", (text) =>
      self.handleDataLoaded(text)
    );
 
    this.$eventHub.$on("storeCompletedEvent", (show) =>
      getTableData(this.$store, "users/bots/list", (text) =>
        self.handleDataLoaded(text)
      )
    );
  },
  beforeDestroy() {
    this.$eventHub.$off("storeCompletedEvent");
  },
  destroyed: function () {
    let self = this;
    // clearInterval(self.intervalid1)
    console.log("destroyed");
  },
  props: {
    caption: {
      type: String,
      default: "bots",
    },
    hover: {
      type: Boolean,
      default: true,
    },
    striped: {
      type: Boolean,
      default: true,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      items: [],
      fields: [
        { key: "id", thStyle:{color: 'white'}, tdClass:'bg-dark', label: 'ID' },
        { key: "name", thStyle:{color: 'white'}, tdClass:'bg-dark', label: 'Name' },
        { key: "is_updating", thStyle:{color: 'white'}, tdClass:'bg-dark', label: 'Updating Status' },
        { key: "is_pending", thStyle:{color: 'white'}, tdClass:'bg-dark', label: 'Installed' },
        { key: "is_accessible", thStyle:{color: 'white'}, tdClass:'bg-dark', label: 'Accessible' },
        { key: "created", thStyle:{color: 'white'}, tdClass:'bg-dark', label: 'Created On' },
        {key: "actions", thStyle:{color: 'white'}},
      ],
      currentPage: 1,
      intervalid1: null,
      perPage: 10,
      selectedCountry: "0",
      totalRows: 0,
      isBusy: true,
      tablefilter: "",
      showNested: false,
      botTypes: [
        {
          text: "default",
          value: 1,
        },
      ],
      new_bot: {},
      nameAvailable: true,
      checking: false,
    };
  },
  computed: {
    validation() {
      return this.nameAvailable && this.new_bot.name.length > 0;
    },
  },
  methods: {
    genNewStore() {
      return {
        name: "",
        bot_type: 1,
      };
    },
    createBot() {
      this.isBusy = true;

      // clean up shop name

      const replaced = this.new_bot.name
        .replace(/[^a-z0-9]/gi, "")
        .toLowerCase();

      this.new_bot.name = replaced;

      createItemJsonPost(
        this.$store,
        `users/bots/create`,
        this.new_bot,
        (text) => this.onCreateComplete(text)
      );
    },
    onCreateComplete(resp) {
      this.isBusy = false;

      if (resp.code === 200) {
        this.$toasted.show("Creation Successful", opts);
        this.showNested = false;

        this.$refs.shopmodal.close();

        let self = this;
        getTableData(this.$store, "users/bots/list", (text) =>
          self.handleDataLoaded(text)
        );
      } else {
        console.log(resp);

        if (resp.code === 401) {
          this.$toasted.show(
            "Create Failed: You have exceeded the allowed number of bots ",
            opts
          );
        } else {
          this.$toasted.show("Create Failed: please check if your plan allows this feature", opts);
        }
      }
    },
    openNested() {
      this.showNested = true;
      this.new_bot= this.genNewStore();
      this.$refs.shopmodal.open();
    },
    closeNested() {
      this.showNested = false;
    },
    handleDataLoaded(resp) {
      console.log(resp);
      this.items = resp.response.bots;
      this.isBusy = false;
    },
    handleShopCheckLoaded(resp) {
      console.log(resp);
      this.checking = false;
      this.nameAvailable = !resp.response.exists;
    },
    checkShopName(shop_name) {
      if (shop_name.length > 0) {
        this.checking = true;
        getTableData(
          this.$store,
          "users/shops/search?name=" + shop_name,
          (text) => this.handleShopCheckLoaded(text)
        );
      }
    },
    handleNameChange(newval) {
      console.log(newval);
      this.checkShopName(newval);
    },
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "secondary"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
    getRowCount(items) {
      if (items === null) {
        return 0;
      }
      return items.length;
    },
    userLink(id) {
      return `bots/${id.toString()}`;
    },
    rowClicked(id) {
      const userLink = this.userLink(id);
      this.$router.push({ path: userLink });
    },
  },
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>